import React from 'react';
import Icon from '../Icon';

const Download = (): JSX.Element => <Icon name='icon-web-24-download' />;

export default Download;
